import {type FunctionalComponent, h} from '@stencil/core';
import type {GuidedApiQuickLink} from '../api';
import {Chips} from './chips';
import { mapStatusToColor, mapStatusToIcon } from './utils';

export interface QuickQuoteLinkProps{
    guidedlinkitem: GuidedApiQuickLink,
    clickHandler: CallableFunction,
    labelProvider?: CallableFunction,
}

export const QuickQuoteLink:FunctionalComponent<QuickQuoteLinkProps> = (props) => {

    const {clickHandler, guidedlinkitem:link, labelProvider} = props;
    let quoteStatusKey = link._original.status;
    if(quoteStatusKey != null && quoteStatusKey != undefined)
    {
      const trimmedStatus = quoteStatusKey.replace(',', '').replace(/\s/g, '');
      quoteStatusKey = `quotes.status.${trimmedStatus}`;
    }

    return <li class="guided-pane__quick-links-section-item guided-pane_item">
      <a
        class="guided-pane__quick-link"
        href={link.openUrl}
        onClick={e => clickHandler(link, e, 'quicklinks')}
        onContextMenu={e => clickHandler(link, e, 'quicklinks')}
      >
        <div class='guided-pane__quick-link-container'>
          <p class="guided-pane__quick-link-p">
            {link.chips && link.chips.beforeTitle ? <Chips chips={link.chips.beforeTitle}></Chips> : ''}
            <span class='guided-pane__quick-link-text' innerHTML={link.markup || link.title}/>

            {link.chips && link.chips.afterTitle ? <Chips chips={link.chips.afterTitle}></Chips> : ''}
          </p>

        </div>
        <div class="guided-pane__quick-link-description">
          <svs-status
            class="guided-pane__quick-link-status"
            label={labelProvider(quoteStatusKey, link._original.status)}
            color={mapStatusToColor(link._original.status)}
            type={mapStatusToIcon(link._original.status)}
            privateCard={true}
          ></svs-status>
          <span> | {labelProvider('pq', 'PQ')} - {link._original.pqNumber}</span>
          <span style={{ 'margin-left': '0.5em' }}> | {labelProvider('id', 'ID')}  {link._original.customerId}</span></div>
      </a>
    </li>
    ;
};
